import About from '../../components/About';
import Resume from '../../components/Resume';
import Life from '../../components/Life';
import Works from '../../components/Works';
import Contact from '../../components/Contact';

import client1Image from '../img/client_1.png';
import client2Image from '../img/client_2.png';
import client3Image from '../img/client_3.png';
import client4Image from '../img/client_4.png';
import testi3Image from '../img/testi3.png';
import testi4Image from '../img/testi4.png';
import work1Image from '../img/work1.jpg';
import work2Image from '../img/work2.jpg';
import work3Image from '../img/work3.jpg';
import work4Image from '../img/work4.jpg';
import work5Image from '../img/work5.jpg';
import work6Image from '../img/work6.jpg';
import work7Image from '../img/work7.jpg';
import work8Image from '../img/work8.jpg';
import blog1Image from '../img/blog1.jpg';
import blog2Image from '../img/blog2.jpg';
import blog3Image from '../img/blog3.jpg';
import blog4Image from '../img/blog4.jpg';
import blog5Image from '../img/blog5.jpg';
import blog6Image from '../img/blog6.jpg';

import ResumePDF from '../pdfs/Gaurav-Gupta-Resume.pdf';

export const app = {
  sections: ['about', 'resume', 'works', 'life', 'contacts'],
  menuItems: [
    { id: 'about', icon: 'fa-user-o', text: 'About' },
    { id: 'resume', icon: 'fa-list-alt', text: 'Resume' },
    { id: 'works', icon: 'fa-object-ungroup', text: 'Works' },
    { id: 'life', icon: 'fa-solid fa-heartbeat', text: 'Life' },
    { id: 'contacts', icon: 'fa-envelope-o', text: 'Contact' },
  ],
  profile: {
    name: 'Gaurav Gupta',
    title: 'Full Stack Developer',
    socialLinks: [
      { icon: 'fa-linkedin', url: 'https://www.linkedin.com/in/gaurav-quasar/' },
      { icon: 'fa-github', url: 'https://github.com/gaurav-quasar' },
    ],
    resume: {
      text: 'Review Resume',
      file: ResumePDF,
    },
  },
  components: {
    about: About,
    resume: Resume,
    works: Works,
    life: Life,
    contacts: Contact,
  },
};

export const about = {
  personalInfo: {
    name: 'Gaurav Gupta',
    description:
      " A passionate software developer based in Kitchener, Ontario, Canada. As a versatile full-stack developer, I'm comfortable working across the entire technology spectrum, but my true enthusiasm lies in crafting exceptional front-end experiences. I specialize in building applications with ReactJS, Node.js, GraphQL, and Next.js, constantly expanding my skill set to stay at the forefront of web development. With every line of code, I strive to make the web a more beautiful and efficient place. I'm always eager to learn new technologies and improve my skills, ensuring that I can deliver cutting-edge solutions to complex problems.",
    details: [
      // { label: 'Age', value: '24' },
      // { label: 'Residence', value: 'USA' },
      // { label: 'Freelance', value: 'Available' },
      // { label: 'Address', value: 'London, UK' },
    ],
  },
  skills: [
    {
      icon: 'fa-html5',
      name: 'Front-End',
      description:
        "My front-end skills are extensive and up-to-date. I have a strong command of modern JavaScript, including ECMAScript 2024, and TypeScript. My expertise in React.js, Redux, and Next.js forms the core of my front-end capabilities. I'm also proficient in styling with Tailwind CSS, Bootstrap, and SCSS.",
    },
    {
      icon: 'fa-code',
      name: 'Back-End',
      description:
        "I'm well-versed in Node.js and Express, which complement my front-end skills for full-stack development. My knowledge extends to Python frameworks like Django and Pyramid, showcasing my versatility. My experience with GraphQL indicates my ability to work with modern API architectures.",
    },
    {
      icon: 'fa-database',
      name: 'Databases',
      description:
        'I have a broad range of database skills, covering both SQL and NoSQL technologies. My proficiency includes MongoDB, PostgreSQL, MySQL, ArangoDB, and Cassandra. This diverse knowledge allows me to choose and work with the most appropriate database solution for any given project.',
    },
    {
      icon: 'fa-cloud',
      name: 'Cloud & DevOps',
      description:
        'My skills in AWS, Docker, and Jenkins demonstrate my capability to work in cloud environments and implement DevOps practices. These skills are crucial for deploying and maintaining modern web applications at scale.',
    },
    {
      icon: 'fa-cogs',
      name: 'Development Tools & Practices',
      description:
        "I'm adept at using a variety of development tools such as NPM, PNPM, Yarn, Webpack, Babel, ESLint, and Prettier. My experience with IDEs like VS Code and IntelliJ IDEA, coupled with my proficiency in Git, indicates a strong foundation in modern development practices. My familiarity with JIRA and Confluence suggests experience with project management and collaboration tools.",
    },
    {
      icon: 'fa-shield',
      name: 'Security',
      description:
        "My knowledge of security tools like Trivy and Snyk shows an awareness of the importance of security in software development, which is increasingly critical in today's landscape.",
    },
  ],
  pricingPlans: [
    {
      icon: 'fa-battery-half',
      name: 'Basic',
      price: 22,
      features: [
        'Web Development',
        'Advetising',
        'Game Development',
        'Music Writing',
        'Photography',
      ],
      disabledFeatures: ['Music Writing', 'Photography'],
    },
    {
      icon: 'fa-battery-full',
      name: 'Pro',
      price: 48,
      features: [
        'Web Development',
        'Advetising',
        'Game Development',
        'Music Writing',
        'Photography',
      ],
      disabledFeatures: [],
    },
  ],
  clients: [client1Image, client2Image, client3Image, client4Image],
  testimonials: {
    title: 'Recommendations',
    items: [
      {
        text: 'Gaurav was such a great source of inspiration and positive energy for everyone in our team. I worked with him for almost a year on a web development project where he consistently demonstrated his abilities as an amazing team player and a hard worker both when working in pairs and individually.',
        name: 'Eshun Sharma',
        position: 'Senior Frontend Developer',
        image: testi3Image,
      },
      {
        text: 'Gaurav is a quick learner, very quick at adapting to new challenges and shows good dedication to the craft. He is very patient and is a good listener(helps in solving many day to day issues). A good team mate.',
        name: 'Prashanth H.',
        position: 'Software Developer',
        image: testi4Image,
      },
    ],
  },
  funFacts: [
    { icon: 'fa-music', text: '80 Albumes Listened' },
    { icon: 'fa-trophy', text: '15 Awards Won' },
    { icon: 'fa-coffee', text: '1 000 Cups of coffee' },
    { icon: 'fa-flag', text: '10 Countries Visited' },
  ],
};

export const contacts = {
  title: 'Get in Touch',
  mapUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92718.26543926279!2d-80.55888755265376!3d43.43040464457731!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882bf48c03ee5105%3A0x9525f8e6df5f544b!2sKitchener%2C%20ON!5e0!3m2!1sen!2sca!4v1733877591871!5m2!1sen!2sca',
  infoList: [
    { label: 'Address', value: 'Kitchener, Canada' },
    { label: 'Email', value: 'gaurav.quasar@gmail.com' },
    { label: 'Freelance', value: 'Available' },
  ],
  formTitle: 'Contact Form',
  formFields: [
    { name: 'name', placeholder: 'Full Name', type: 'text', colSize: 6 },
    { name: 'email', placeholder: 'Email Address', type: 'text', colSize: 6 },
    { name: 'message', placeholder: 'Your Message', type: 'textarea', colSize: 12 },
  ],
};

export const resume = {
  title: 'Resume',
  experience: {
    title: 'Experience',
    icon: 'fa-briefcase',
    items: [
      {
        date: '2023 - Present',
        name: 'Staff Software Engineer',
        company: 'WebMocha LLC',
        description: (
          <>
            <strong>Responsibilities:</strong>
            <ul>
              <li>
                - Develop interactive user interfaces utilizing the React.js framework, enhancing
                user experience and increasing customer engagement.
              </li>
              <li>
                - Collaborate closely with cross-functional teams to design and implement highly
                efficient and scalable React components, reducing development time.
              </li>
            </ul>
          </>
        ),
        active: true,
      },
      {
        date: '2020 - 2023',
        name: 'Cloud Developer Expert',
        company: 'Hewlett Packard Enterprise',
        description: (
          <>
            <strong>Responsibilities:</strong>
            <ul>
              <li>
                - Led a team of 7 highly qualified developers in the development of cloud-native
                applications.
              </li>
              <li>
                - Designed and architected scalable and maintainable cloud-native applications.
              </li>
            </ul>
          </>
        ),
      },
      {
        date: '2016 - 2020',
        name: ' Technical Lead - Product Development',
        company: 'Harman Connected Services',
        description: (
          <>
            <strong>Responsibilities:</strong>
            <ul>
              <li>
                - Designing and developing applications with clean and efficient code using React
                and related libraries
              </li>
              <li>
                - Developing new user-facing features and ensuring the technical feasibility of
                UI/UX designs
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  education: {
    title: 'Education',
    icon: 'fa-university',
    items: [
      {
        date: '2023 – Present',
        name: 'Web Development | Ontario College Graduate Certificate',
        company: 'Conestoga College, Kitchener, Canada',
        description: 'Focused on web development, modern frameworks, and design principles.',
        active: true,
      },
      {
        date: '2009 – 2010',
        name: 'Embedded Systems Designs | Post Graduate Certificate',
        company: 'Centre for Development of Advanced Computing, Bangalore, India',
        description: 'Specialized in embedded systems design and advanced computing technologies.',
      },
      {
        date: '2005 – 2009',
        name: 'Electronics and Communication | Bachelor of Technology',
        company: 'Uttar Pradesh Technical University, Ghaziabad, India',
        description: 'Studied electronics, communication systems, and engineering principles.',
      },
    ],
  },
  skills: {
    title: 'My Skills',
    databases: {
      title: 'DataBases',
      icon: 'fa-database',
      items: [
        { name: 'MongoDB', percentage: 90 },
        { name: 'PostgreSQL', percentage: 90 },
        { name: 'MySQL', percentage: 80 },
        { name: 'Cassandra', percentage: 80 },
        { name: 'ArangoDB', percentage: 85 },
      ],
    },
    backend: {
      title: 'Back-End',
      icon: 'fa-code',
      items: [
        { name: 'Node.js', percentage: 90 },
        { name: 'Express', percentage: 85 },
        { name: 'Django', percentage: 75 },
        { name: 'Pyramid', percentage: 65 },
        { name: 'GraphQL', percentage: 90 },
      ],
    },
    frontend: {
      title: 'Front End',
      icon: 'fa-html5',
      items: [
        { name: 'React.js', percentage: 90 },
        { name: 'Angular', percentage: 60 },
        { name: 'Redux', percentage: 90 },
        { name: 'Zustand', percentage: 85 },
        { name: 'Tailwind', percentage: 80 },
        { name: 'Bootstrap', percentage: 75 },
        { name: 'Material UI', percentage: 70 },
        { name: 'JQuery', percentage: 75 },
      ],
    },
    knowledge: {
      title: 'Strengths',
      icon: 'fa-list',
      items: [
        'Ability to learn from mistakes',
        'Ability to prioritize',
        'Action oriented',
        'Analytical',
        'Curiosity',
        'Decision making',
        'Dependability',
        'Discipline',
        'Efficiency',
        'Flexible/Adaptable',
        'Honesty',
        'Leadership',
        'Learning Agility',
        'Logical thinking',
        'Positive attitude',
        'Self Motivated',
        'Team oriented',
        'Communicative',
      ],
    },
  },
  testimonials: {
    title: 'Quote',
    items: [
      {
        text: 'Gaurav was such a great source of inspiration and positive energy for everyone in our team. I worked with him for almost a year on a web development project where he consistently demonstrated his abilities as an amazing team player and a hard worker both when working in pairs and individually. ',
        name: 'Eshun Sharma',
        position: 'Senior Frontend Developer',
        image: testi3Image,
      },
      {
        text: 'Gaurav is a quick learner, very quick at adapting to new challenges and shows good dedication to the craft. He is very patient and is a good listener(helps in solving many day to day issues). A good team mate.',
        name: 'Prashanth H.',
        position: 'Software Developer',
        image: testi4Image,
      },
    ],
  },
};

export const works = {
  title: 'Recent Works',
  filterButtons: [
    { value: 'all', label: 'ALL', active: true },
    { value: 'webmocha', label: 'WebMocha' },
    { value: 'hpe', label: 'HPE' },
    { value: 'harman', label: 'Harman' },
    { value: 'toshiba', label: 'Toshiba' },
    { value: 'techm', label: 'Tech Mahindra' },
  ],
  projects: [
    {
      image: work1Image,
      icon: 'fa-area-chart',
      name: 'Mapbook',
      category: 'webmocha',
      description:
        "The HPE GreenLake Mapbook is a valuable tool designed to streamline the process of understanding and selling HPE GreenLake solutions. It serves as a comprehensive guide for HPE's direct sales team, ecosystem partners, and other team members, aligning the available offerings with customer needs and preferences",
    },
    {
      image: work2Image,
      icon: 'fa-bar-chart',
      name: 'Brand Central',
      category: 'webmocha',
      description:
        'The Hewlett Packard Enterprise brand is a living entity that evolves over time. Whether you’re a marketing professional, an agency or only occasionally engage with the brand it is important to always stay up to date with the latest iterations and continue to strengthen your knowledge.',
    },
    {
      image: work3Image,
      icon: 'fa-medkit',
      name: 'Stanford Scope',
      category: 'webmocha',
      description:
        "Scope is an award-winning blog founded in 2009 and produced by the Office of Communications at Stanford Medicine. If you're curious about the latest advances in medicine and health and enjoy compelling, fresh and easily digestible news and features, then we've got just the thing.",
    },
    {
      image: work4Image,
      icon: 'fa-cogs',
      name: 'Aruba Central',
      category: 'hpe',
      description:
        'Aruba Central is an end to end cloud based network management licensed solution for network administrators who configure and monitor(using ML based Network Insights) their networks with Aruba Devices such as Instant APs, Aruba Switches, and Aruba SD-WAN Gateways.',
    },
    {
      image: work5Image,
      icon: 'fa-flask',
      name: 'Eureka Health AI',
      category: 'harman',
      description:
        'The ConcertAI’s eureka Health platform represents a suite of tools designed to support multiple use cases that inform clinical and business decision-making for life sciences users. eureka Health enables users to identify and analyze patient populations via ConcertAI’s longitudinal Real-World Data (RWD) for the purposes of clinical trial design, trial feasibility evaluation, and outcomes analyses.',
    },
    {
      image: work6Image,
      icon: 'fa-pie-chart',
      name: 'Simmons OneView',
      category: 'harman',
      description:
        'Simmons OneView contains extensive consumer survey data for large samplings of individuals and American households. It allows cross tabulation of hundreds of consumer product categories and usage data for over 8,000 brands, inclusive of consumer media habits, diverse demographic categories and psychographic (attitudinal and lifestyle) profiles.',
    },
    {
      image: work7Image,
      icon: 'fa-print',
      name: 'WebPanel',
      category: 'toshiba',
      description:
        'Highly intuitive user interface with the best functionality enabling the printer to be more user-friendly in a corporate environment.',
    },
    {
      image: work8Image,
      icon: 'fa-tasks',
      name: 'SOE CAPMAN',
      category: 'techm',
      description:
        'SOE - CapMan is a web portal showing detailed information on the complete BTGS Global network and its suppliers. It is an integral part of the sales tools system stack; and will grow together with BT’s product and pricing tools.',
    },
  ],
};

export const life = {
  title: 'Hobbies',
  hobbies: [
    {
      image: blog1Image,
      alt: 'Exploring Distant Lands',
      date: 'April 28, 2020',
      title: 'Exploring Distant Lands',
      excerpt:
        'Traveling to far-off destinations fills me with wonder and opens my mind to endless possibilities.',
    },
    {
      image: blog2Image,
      alt: 'Trekking',
      date: 'April 28, 2020',
      title: 'Trekking',
      excerpt:
        'Trekking gives me peace and thrill, as I journey through scenic trails and breathtaking landscapes.',
    },
    {
      image: blog3Image,
      alt: 'Capturing Moments',
      date: 'April 28, 2020',
      title: 'Capturing Moments',
      excerpt:
        'I find joy in capturing life’s essence, turning everyday moments into timeless treasures.',
    },
    {
      image: blog4Image,
      alt: 'Video Games',
      date: 'April 28, 2020',
      title: 'Video Games',
      excerpt:
        'Video games are my favorite way to unwind, sharpen my skills, and experience epic adventures.Let me know if you’d like any tweaks!',
    },
    {
      image: blog5Image,
      alt: 'Tech Freak',
      date: 'April 28, 2020',
      title: 'Tech Freak',
      excerpt:
        'I’m passionate about technology, always eager to learn about the next big thing and how it can change our world.',
    },
    {
      image: blog6Image,
      alt: 'Astronomy',
      date: 'April 28, 2020',
      title: 'Astronomy',
      excerpt:
        'I love exploring the mysteries of the stars, planets, and galaxies. The night sky fills me with wonder and curiosity.',
    },
  ],
  pagination: [
    { number: '1', current: true },
    { number: '2', current: true },
    { number: 'Next', current: false },
  ],
};
